/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/rows.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    rowsModule
} from "../../../grids/grid_core/views/m_rows_view";
import gridCore from "../m_core";
export var RowsView = rowsModule.views.rowsView;
gridCore.registerModule("rows", rowsModule);
